<template>
  <div>
    <v-card
      :to="'/category/' + category.slug"
      v-if="category.slug"
      max-width="1200"
      class="mx-auto"
      elevation="0"
    >
      <v-img
        height="200px"
        width="200px"
        :src="getImage('/' + category.image)"
        class="red--text hidden-sm-and-down"
      >
      </v-img>
      <v-card-text
        style="height: 80px; overflow: hidden"
        class="fill-height align-end hidden-sm-and-down"
        v-text="category.name"
      ></v-card-text>

      <v-container class="ma-0 pa-0" grid-list-sm v-if="products">
        <v-subheader> All products </v-subheader>
        <v-layout wrap>
          <v-flex
            v-for="product in products"
            :key="`product-` + product.id"
            class="hidden-sm-and-down"
            xs2
          >
            <product-item :product="product" height="200px" width="200px" />
          </v-flex>
          <v-flex
            v-for="product in products"
            :key="`product-` + product.id"
            class="hidden-sm-and-up"
            xs6
          >
            <product-item :product="product" height="200px" width="200px" />
          </v-flex>
        </v-layout>
      </v-container>
      <template>
        <div class="text-center">
          <v-pagination
            v-model="page"
            @input="go"
            :length="lengthPage"
            :total-visible="5"
          ></v-pagination>
        </div>
      </template>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {
    ProductItem: () =>
      import(/* webpackChunkName: "product-item" */ "@/components/ProductItem.vue"),
  },
  data: () => ({
    category: {}, // objek category
    products: [], // daftar buku pada category tersebut
    page: 0,
    lengthPage: 0,
  }),
  created() {
    this.go();
  },
  methods: {
    go() {
      let { slug } = this.$route.params;
      let url = "/ecommerce-categories/slug/" + slug;
      url = url + "?page=" + this.page;
      url = encodeURI(url);
      this.axios
        .get(url)
        .then((response) => {
          let { data } = response.data;
          let category = data;
          this.category = category;
          this.products = category.products.data;
          this.page = category.products.current_page;
          this.lengthPage = category.products.last_page;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
  },
};
</script>
